import {connect, Dispatch} from '@modifi/redux'
import {aPush} from '@modifi/router'

import DynamicEntriesTable from './DynamicEntriesTable'

export type {DynamicEntry} from './DynamicEntriesTable'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = () => ({})

const mapDispatchToProps = (dispatch: Dispatch): Record<string, any> => ({
  redirect: (route: string) => dispatch(aPush(route)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DynamicEntriesTable)
